module.exports = __webpack_public_path__ + "img/zc_photo.06a72805.png";